







































































import colors from 'library/assets/vars/colors.json'

export default

	middleware: 'unauthenticated'

	data: ->
		loading: false
		recover: false
		errors: []
		success: []

	mounted: ->
		if @$store.state.customer?.email
			@$router.push '/account'

	computed:
		title: -> if @recover then 'Recover Password' else 'Customer Login'

		simulatedMarqueeBlock: ->
			backgroundColor: colors['light-blue']
			balanceText: true
			copy: do =>
				copy = "<h1 class='style-h2'>Customer Login</h1>"
				return copy

	methods:

		toggleForm: -> @recover = !@recover

		# the login form submission
		formSubmit: (e) ->
			e.preventDefault()

			@errors = []
			@success = []

			form = @$refs.form
			email = form.elements['email'].value
			password = form.elements['password'].value

			@loading = true
			try
				login = await @$store.dispatch 'customer/login', { email, password }
				@$router.push '/account'
			catch e then @errors = e.messages || ['Unknown error']
			finally @loading = false

		# trigger an email to recover your password
		recoverPassword: (e) ->
			email = @$refs.recoveryEmail.$el.querySelector('input').value
			@loading = true
			try
				login = await @$store.dispatch 'customer/recoverPassword', { email }
				@success.push 'An email has been sent with password reset instructions'
			catch e then @errors = e.messages || ['Unknown error']
			finally @loading = false


